import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import { userIdZodSchema } from "@@/shared/users/user-id";
import { generateWordSlug } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import z from "zod";
import { orderItemIdZodSchema } from "../../../order-items/order-item-id";
import { orderItemStatusZodSchema } from "../../../order-items/statuses/order-item-status";
import { signatureFactory } from "../../signature-factory";
import type {
    _OrderEventBaseFactoryParams} from "../_order-base.event";
import {
    _orderEventBaseFactory,
    _orderEventBaseZodObject,
} from "../_order-base.event";

const orderItemStatusSetEventZodObject = _orderEventBaseZodObject.merge(
    z.object({
        providerId: providerIdZodSchema,
        orderItemId: orderItemIdZodSchema,
        type: z.literal("ORDER_ITEM_STATUS_SET"),
        status: orderItemStatusZodSchema,
        setBy: userIdZodSchema,
    }),
);
type OrderItemStatusSetEvent = z.infer<typeof orderItemStatusSetEventZodObject>;
const orderItemStatusSetEventZodSchema =
    orderItemStatusSetEventZodObject as z.ZodSchema<OrderItemStatusSetEvent>;

type FactoryParams = _OrderEventBaseFactoryParams &
    Except<OrderItemStatusSetEvent, "_type" | "signature">;

const orderItemStatusSetEventFactory = (
    params: FactoryParams,
): OrderItemStatusSetEvent => {
    return {
        ..._orderEventBaseFactory({
            orderId: params.orderId,
            orderGroupId: params.orderGroupId,
            _version: params._version,

            providerId: params.providerId,
            providerSlug: params.providerSlug,
            signature: signatureFactory(
                params.orderId,
                "ORDER_ITEM_STATUS_SET",
                [generateWordSlug()],
            ),
        }),
        type: "ORDER_ITEM_STATUS_SET",
        status: params.status,
        setBy: params.setBy,
        providerId: params.providerId,
        orderItemId: params.orderItemId,
    };
};

const isOrderItemStatusSetEvent = (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    event: any,
): event is OrderItemStatusSetEvent => {
    return (
        event._type === "ORDER_EVENT" && event.type === "ORDER_ITEM_STATUS_SET"
    );
};

export {
    isOrderItemStatusSetEvent,
    orderItemStatusSetEventFactory,
    orderItemStatusSetEventZodObject,
    orderItemStatusSetEventZodSchema,
};
export type { OrderItemStatusSetEvent };
